import React, { Component } from 'react';
import radium from 'radium';
import $j from 'jquery';

class CardStatus extends Component {
  setPercentage = (percentage, doAnimate) => {
    // console.log('percentage::', percentage);
    if (!doAnimate) {
      $j(this.progressBar).css('width', percentage + '%');
    } else {
      $j(this.progressBar)
        .stop(true, true)
        .animate(
          {
            width: percentage + '%'
          },
          900
        );
    }
    if (percentage === 100) $j(this.progressBar).addClass('complete');
    else $j(this.progressBar).removeClass('complete');
  };

  renderProgress = (isComplete, noTransition) => (
    <div className={'cardProgressBarContainer' + (noTransition ? ' noTransition' : '')}>
      <div
        ref={ref => (this.progressBar = ref)}
        className={'cardProgressBar' + (isComplete ? ' complete' : '')}
      />
    </div>
  );

  render() {
    const card = this.props.card;
    const isComplete = this.props.isComplete;
    const noTransition = this.props.isScrollBased;
    if (!card.performance) return null;
    return (
      <div className="CardProgressContainer">{this.renderProgress(isComplete, noTransition)}</div>
    );
  }
}

export default radium(CardStatus);
